module.exports = __webpack_public_path__ + "static/img/voice5.7296a6cb.png";